import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-step-question-help',
  templateUrl: './step-question-help.component.html',
  styleUrls: ['./step-question-help.component.scss'],
})
export class StepQuestionHelpComponent implements OnInit {

  public helpSections: any[] = [];

  constructor() {
    this.helpSections = [
      {
        "title": "What is a single question?",
        "description": "A single question is similar to a quiz but is made up to only one multiple choice question. It does not have an introduction, confirmation or results page. ",
        "subSections": [],
        "collapsed": true
      },
      {
        "title": "How do I edit the question details?",
        "description": "To edit the question details, select a question from step 2. This allows you to edit all the details of the question.",
        "subSections": [
          {
            "title": "What are the different question types?",
            "description": "There are two different types of question. There are Standard questions and Media questions. Media questions allow you to attach media to the answers in a question. The standard questions do not allow you to do this and instead rely on text to be used in the answers.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What are question actions?",
            "description": "Question actions allow you to set actions when certain conditions occur when a user interacts with the question. An example of this is adding an image to appear to the learner if they get the question correct.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What are answer actions?",
            "description": "Answer actions allow you to set actions when certain conditions occur when a user interacts with an answer on a question. An example of this is that when a user select answer B, the question will restart.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What is the correct and incorrect feedback for?",
            "description": "The correct and incorrect feedback is used to display text feedback to the learner when they submit the question.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "How is the correct and incorrect feedback displayed to the learner?",
            "description": "The correct and incorrect feedback is displayed across the bottom half of the quiz above the question number navigation. If the correct feedback is displayed it has a green border. If the incorrect feedback is displayed it has a red border.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "For the Media question type, how do i attach media to answers?",
            "description": "To attach media to answers, the question type must be set to Media. Next to each of the answers, there is an 'Add Media' button which will display the answer media section. From this section you can upload media, select existing media, preview, edit the properties of the media and remove the media on the answer.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What media can be attached to answers?",
            "description": "The media that can be attached to answers are videos, images, audio and also link to a scene. The videos, images and audios can be selected from existing media or upload new media.",
            "subSections": [],
            "collapsed": true
          },
          {
            "title": "What does enabling the text-to-speech property do on questions?",
            "description": "The 'Enable text-to-speech' property is used to enable the text-to-speech capability for all the questions. A speaker icon will appear at the side of the quiz to play a verbal version of the text on the question currently displayed to the learner.",
            "subSections": [],
            "collapsed": true
          }
        ],
        "collapsed": true
      }
    ];
  }

  ngOnInit() { }

  toggleCollapseHelpSection(index: number) {
    this.helpSections[index].collapsed = !this.helpSections[index].collapsed;
  }

  toggleCollapseSubHelpSection(index: number, subIndex: number) {
    this.helpSections[index].subSections[subIndex].collapsed = !this.helpSections[index].subSections[subIndex].collapsed;
  }

}
